<div class="pwc-card" aria-labelledby="pwc-title">
  <div class="pwc-head">
    <div>
      <h2 id="pwc-title">Password</h2>
      <p>Changing it signs you out on your other devices.</p>
    </div>
    @if (!open) {
      <button type="button" class="af-btn af-btn--ghost pwc-open" (click)="start()">Change password</button>
    }
  </div>

  @if (done) {
    <div class="af-alert af-alert--success" role="status"><p>Your password has been changed. We've emailed you to confirm.</p></div>
  }

  @if (open) {
    @if (error) {
      <div class="af-alert af-alert--error" role="alert"><p>{{ error }}</p></div>
    }
    <form class="af-form" (ngSubmit)="submit()" novalidate>
      <app-password-field [control]="current" label="Current password" inputId="pwc-current"
        autocomplete="current-password" [serverError]="currentError"></app-password-field>
      <app-password-field [control]="form.controls.password" label="New password" inputId="pwc-new"
        autocomplete="new-password" [showStrength]="true" [serverError]="passwordError"></app-password-field>
      <app-password-field [control]="form.controls.confirm" label="Confirm new password" inputId="pwc-confirm"
        autocomplete="new-password"></app-password-field>
      @if (form.controls.confirm.errors?.['mismatch'] && form.controls.confirm.touched) {
        <p class="af-error af-mismatch">The passwords don't match.</p>
      }
      <div class="pwc-actions">
        <a class="af-link af-link--small" routerLink="/forgot-password">Forgot your current password?</a>
        <span class="pwc-buttons">
          <button type="button" class="af-btn af-btn--ghost" (click)="cancel()" [disabled]="busy">Cancel</button>
          <button type="submit" class="af-btn af-btn--primary" [disabled]="busy">
            @if (busy) { <span class="af-spinner" aria-hidden="true"></span> Saving… } @else { Save password }
          </button>
        </span>
      </div>
    </form>
  }
</div>
